var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudent = function SvgStudent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "m17.698 4.407-7.5-2.5a.63.63 0 0 0-.396 0l-7.5 2.5A.625.625 0 0 0 1.875 5v6.25a.625.625 0 1 0 1.25 0V5.867l2.624.874a5 5 0 0 0 1.614 6.88c-1.407.55-2.622 1.549-3.511 2.913a.626.626 0 1 0 1.046.683C6.076 15.41 7.935 14.375 10 14.375s3.924 1.035 5.102 2.842a.625.625 0 0 0 1.046-.683c-.889-1.364-2.109-2.362-3.51-2.914a5 5 0 0 0 1.613-6.875l3.447-1.148a.625.625 0 0 0 0-1.186zM13.75 9.375a3.748 3.748 0 0 1-6.412 2.642 3.75 3.75 0 0 1-.358-4.865l2.822.938a.63.63 0 0 0 .396 0l2.822-.938a3.74 3.74 0 0 1 .73 2.223M10 6.841 4.477 5 10 3.159 15.523 5z"
  })));
};
export default SvgStudent;